@if (loading || seasonCars.length > 0) {
    <div class="card mt-4">
        <div class="text-xl font-semibold mb-4">Autos</div>

        @if (loading) {
            <div class="flex items-center gap-2 text-surface-500 py-2">
                <i class="pi pi-spin pi-spinner"></i>
                <span>Autos werden geladen ...</span>
            </div>
        } @else {
            <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                @for (entry of seasonCars; track entry.season_id) {
                    <div class="player-car-card">
                        <div class="car-visual">
                            @if (imageUrl(entry); as carImage) {
                                <img [src]="carImage" alt="Auto" class="car-img" loading="lazy" />
                            } @else {
                                <i class="pi pi-car car-placeholder"></i>
                            }
                        </div>
                        <div class="car-meta">
                            <div class="season-name">{{ entry.season_name || 'Saison ' + entry.season_id }}</div>
                            <div class="car-name">{{ entry.car_name || 'Kein Auto gewählt' }}</div>
                        </div>
                    </div>
                }
            </div>
        }
    </div>
}
